export const FETCH_PLAYER_DETAILS = 'FETCH_PLAYER_DETAILS';
export const FETCH_PLAYER_DETAILS_SUCCESS = 'FETCH_PLAYER_DETAILS_SUCCESS';
export const FETCH_PLAYER_DETAILS_FAIL = 'FETCH_PLAYER_DETAILS_FAIL';
export const FETCH_PLAYER_EVENTS = 'FETCH_PLAYER_EVENTS';
export const FETCH_PLAYER_EVENTS_SUCCESS = 'FETCH_PLAYER_EVENTS_SUCCESS';
export const FETCH_PLAYER_EVENTS_FAIL = 'FETCH_PLAYER_EVENTS_FAIL';
export const FETCH_PLAYER_ALERTS = 'FETCH_PLAYER_ALERTS';
export const FETCH_PLAYER_ALERTS_SUCCESS = 'FETCH_PLAYER_ALERTS_SUCCESS';
export const FETCH_PLAYER_ALERTS_FAIL = 'FETCH_PLAYER_ALERTS_FAIL';
